import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Path
        d="M20.716 20.15a.437.437 0 00.165-.033h.001l.075-.04a.432.432 0 00.159-.194h0a.43.43 0 00.034-.166V14.05a.434.434 0 00-.866 0v4.62l-6.06-6.06a.433.433 0 00-.546-.055l-.068.055a.433.433 0 000 .613l6.06 6.06h-4.62a.434.434 0 000 .867h5.666zM10.845 10.445a.433.433 0 00.6-.6l-.055-.068-6.06-6.06h4.62a.433.433 0 100-.867H4.283a.426.426 0 00-.085.009l-.08.024a.433.433 0 00-.235.235v0a.438.438 0 00-.033.166V8.95a.434.434 0 00.867 0V4.33l6.06 6.06.068.055z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.3}
      />
    </Svg>
  )
}

export default SvgComponent
